import {
    IWorkflowNode,
    resourceNameWorkflowNode,
} from "motw_core/Entity/IWorkflowNode";
import { RefreshVisibleWorkflowNodesAsync } from "source/app/presentation/MainPanel/Workflows/Helpers/RefreshVisibleWorkflowNodes";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { TouchWorkflowNodeParentsAsync } from "source/app/services/Workflows/ChangeData/TouchWorkflowNodeParentsAsync";

export async function MoveAllChildrenAsync(
    sourceNode: IWorkflowNode,
    destinationNode: IWorkflowNode,
    descendantIds: number[],
    deleteSourceNode: boolean
) {
    await ClientDataProvider.UpdateRecordAsync(
        `${resourceNameWorkflowNode}?id=in.(${descendantIds.join(",")})`,
        { parentid: destinationNode.id }
    );

    if (deleteSourceNode) {
        await ClientDataProvider.DeleteRecordsAsync(
            `${resourceNameWorkflowNode}?id=eq.${sourceNode.id}`
        );
        await TouchWorkflowNodeParentsAsync([
            sourceNode.parentid,
            destinationNode.id,
        ]);
        return;
    }

    await TouchWorkflowNodeParentsAsync([sourceNode.id, destinationNode.id]);
    await RefreshVisibleWorkflowNodesAsync();
}
